<template>
    <section class="main-news">
        <v-container>
            <div class="section-title-wrap">
                <h2 class="section-title primary--text">사업소식</h2>
            </div>

            <v-row>
                <v-col cols="12" lg="7">
                    <v-card height="100%" to="/news/campaign/infant">
                        <div class="overflow-hidden">
                            <v-img src="/images/sub/campaign/infant/thumb.jpg" :aspect-ratio="768 / 432" class="main-news__thumb" />
                        </div>
                        <div class="px-lg-16 py-lg-40">
                            <v-card-subtitle class="pt-lg-0">진행중인 캠페인</v-card-subtitle>
                            <v-card-title class="pb-0 text-truncate-2">
                                위기영아지원 캠페인 <br />
                                '혼자가 된 아이를 따뜻한 품으로'
                            </v-card-title>
                            <v-card-actions class="justify-end pb-lg-0">
                                <v-btn color="primary" large rounded="pill" class="px-16 px-md-24">
                                    <span class="font-size-18 font-size-md-20 text-center">더 알아보기</span>
                                    <v-icon small class="ml-10">mdi-chevron-right</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </div>
                    </v-card>
                </v-col>
                <v-col cols="12" lg="5">
                    <v-row>
                        <v-col cols="12">
                            <v-card v-if="board1" :to="`/community/${board1._id}`" max-height="194">
                                <div class="d-flex align-center">
                                    <v-img height="100%" max-width="40%" :src="board1.thumb" :aspect-ratio="1" class="main-news__thumb" />
                                    <v-sheet max-width="60%">
                                        <v-card-subtitle>재단소식</v-card-subtitle>
                                        <v-card-title>
                                            <div class="text-truncate-3">{{ board1.subject }}</div>
                                        </v-card-title>
                                    </v-sheet>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card v-if="board2" :to="`/community/${board2._id}`" max-height="194">
                                <div class="d-flex align-center">
                                    <v-img height="100%" max-width="40%" :src="board2.thumb" :aspect-ratio="1" class="main-news__thumb" />
                                    <v-sheet max-width="60%">
                                        <v-card-subtitle>후원자 소식</v-card-subtitle>
                                        <v-card-title>
                                            <div class="text-truncate-3">{{ board2.subject }}</div>
                                        </v-card-title>
                                    </v-sheet>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card v-if="board3" max-height="194" :to="`/community/${board3._id}`">
                                <div class="d-flex align-center">
                                    <v-img height="100%" max-width="40%" :src="board3.thumb" :aspect-ratio="1" class="main-news__thumb" />
                                    <v-sheet max-width="60%">
                                        <v-card-subtitle>사업기관 소식</v-card-subtitle>
                                        <v-card-title>
                                            <div class="text-truncate-3">{{ board3.subject }}</div>
                                        </v-card-title>
                                    </v-sheet>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
import api from "@/api";
import download from "downloadjs";
export default {
    data() {
        return {
            board1: null,
            board2: null,
            board3: null,
        };
    },
    methods: {
        async init() {
            api.v1.boards.gets({ params: { code: "newsletter" } }).then((res) => (this.board1 = res.boards[0]));
            api.v1.boards.gets({ params: { code: "supporter" } }).then((res) => (this.board2 = res.boards[0]));
            api.v1.boards.gets({ params: { code: "news" } }).then((res) => (this.board3 = res.boards[0]));
        },
        download(path, rename) {
            api.getResource(path).then((file) => download(file, rename));
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
.main-news {
    padding: 60px 0 40px;
    &__thumb {
        ::v-deep(.v-image__image) {
            transition: all 0.25s ease-in-out;
        }
    }
}
.v-card {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 0 24px 0 rgba(133, 149, 168, 0.25) !important;
    &__subtitle,
    &__title,
    &__actions {
        padding-left: 24px;
        padding-right: 24px;
    }
    &__subtitle {
        color: var(--v-primary-base) !important;
        padding-bottom: 8px;
        font-size: var(--title-font-size-xs);
    }
    &__title {
        padding-top: 0;
        font-size: var(--title-font-size);
        line-height: 1.35;
        font-weight: 500;
        word-break: keep-all;
        transition: color 0.25s ease-in-out;
    }
}
@media (min-width: 1024px) {
    .main-news {
        padding: 120px 0 80px;
    }
    .v-card {
        &:hover {
            .main-news__thumb {
                ::v-deep(.v-image__image) {
                    transform: scale(1.1);
                }
            }
            .v-card__title {
                color: var(--v-primary-base);
            }
        }
    }
}
</style>